import React from 'react'
import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Icon } from '../../../../../../../common/html/icon'
import { Loading } from '../../../../../../../common/loading'
import { Tooltip } from '../../../../../../../common/tooltip'
import { selectLoading } from '../../../../store/slice'
import s from './index.module.scss'
import { PieChartComponent } from './PieChartComponent'
import { PieChartTwoLevelComponent } from './PieChartTwoLevelComponent'

const ScoreBreakdown = ({ isCompare, filterTime, isDynamicReport }) => {
  const loading = useSelector(selectLoading('breakdown'))

  return (
    <div className={s.box}>
      <div className={s.title}>
        <Translate value="riskComponentAnalysis.scoreBreakdown" />
        {!isDynamicReport && (
          <Tooltip
            contentStyle={{
              display: 'flex',
              alignItems: 'center',
              paddingLeft: 4,
            }}
            tooltipStyle={{
              maxWidth: 400,
            }}
            tooltipContent={
              <div className="textCenter" style={{ textAlign: 'justify' }}>
                <Translate value="riskComponentAnalysis.scoreBreakdownTooltip" />
              </div>
            }
          >
            <Icon
              className="icon-info-circle"
              style={{ fontSize: 12, color: '#9C9C9C' }}
            />
          </Tooltip>
        )}
      </div>
      {loading ? (
        <div style={{ height: 100 }} className="positionRelative">
          <Loading />
        </div>
      ) : isCompare ? (
        <PieChartTwoLevelComponent filterTime={filterTime} />
      ) : (
        <PieChartComponent />
      )}
    </div>
  )
}

export default ScoreBreakdown
